import { IconProps } from '.';

const SaveIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142913)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.416992 1.66675C0.416992 0.976392 0.976636 0.416748 1.66699 0.416748H23.0181L29.5837 6.98231V28.3334C29.5837 29.0238 29.024 29.5834 28.3337 29.5834H1.66699C0.976636 29.5834 0.416992 29.0238 0.416992 28.3334V1.66675ZM2.91699 2.91675V27.0834H7.08366V17.0834H22.917V27.0834H27.0837V8.01785L21.9826 2.91675H2.91699ZM20.417 27.0834V19.5834H9.58366V27.0834H20.417Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142913">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SaveIcon;
